/* GIFT REWARD POPUP — Visual-only gift progress popup.
   Reads the cart subtotal and updates each reward card. Does NOT add products nor apply discounts. */
(function () {
  'use strict';
  if (window.customElements.get('gift-reward-popup')) return;
  var AUTO_OPEN_SESSION_KEY = 'gift-reward:auto-opened';

  class GiftRewardPopup extends HTMLElement {
    connectedCallback() {
      this.toggleButton = this.querySelector('.gift-reward__toggle');
      this.panel = this.querySelector('.gift-reward__panel');
      this.backdrop = this.querySelector('.gift-reward__backdrop');
      this.closeButton = this.querySelector('.gift-reward__close');
      this.badge = this.querySelector('.gift-reward__badge');
      this.cards = Array.prototype.slice.call(this.querySelectorAll('.gift-reward__card'));

      this.unreachedTemplate = this.dataset.unreachedTemplate || '';
      this.autoOpen = this.hasAttribute('data-auto-open');
      this.autoOpenOnce = this.hasAttribute('data-auto-open-once');

      this.currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
      this.locale = document.documentElement.lang || undefined;

      this.reachedState = this.cards.map(function () { return false; });
      this.isFirstRender = true;

      this.onToggleClick = this.toggle.bind(this);
      this.onClose = this.close.bind(this);
      this.onKeydown = this.handleKeydown.bind(this);
      this.onCartChange = this.handleCartChange.bind(this);
      this.onCartRefresh = this.fetchCart.bind(this);

      this.toggleButton.addEventListener('click', this.onToggleClick);
      this.closeButton.addEventListener('click', this.onClose);
      if (this.backdrop) this.backdrop.addEventListener('click', this.onClose);
      document.addEventListener('keydown', this.onKeydown);

      // Impact theme events. If the target theme uses different cart events, also wire them here.
      document.documentElement.addEventListener('cart:change', this.onCartChange);
      document.documentElement.addEventListener('cart:refresh', this.onCartRefresh);

      this.fetchCart();
    }

    disconnectedCallback() {
      this.toggleButton.removeEventListener('click', this.onToggleClick);
      this.closeButton.removeEventListener('click', this.onClose);
      if (this.backdrop) this.backdrop.removeEventListener('click', this.onClose);
      document.removeEventListener('keydown', this.onKeydown);
      document.documentElement.removeEventListener('cart:change', this.onCartChange);
      document.documentElement.removeEventListener('cart:refresh', this.onCartRefresh);
    }

    fetchCart() {
      var self = this;
      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { self.update(cart); })
        .catch(function () {});
    }

    handleCartChange(event) {
      if (event && event.detail && event.detail.cart) { this.update(event.detail.cart); }
      else { this.fetchCart(); }
    }

    update(cart) {
      if (!cart) return;
      if (cart.currency) this.currency = cart.currency;
      var subtotal = typeof cart.items_subtotal_price === 'number' ? cart.items_subtotal_price : cart.total_price || 0;

      var reachedCount = 0, newlyUnlocked = false, self = this;
      this.cards.forEach(function (card, index) {
        var threshold = parseInt(card.dataset.threshold, 10) || 0;
        var reached = threshold > 0 && subtotal >= threshold;
        if (reached) reachedCount++;
        if (reached && !self.reachedState[index] && !self.isFirstRender) newlyUnlocked = true;
        self.reachedState[index] = reached;
        card.classList.toggle('is-reached', reached);

        var progress = card.querySelector('.gift-reward__progress');
        var fill = card.querySelector('.gift-reward__progress-fill');
        var ratio = threshold > 0 ? Math.min(subtotal / threshold, 1) : 0;
        if (fill) fill.style.width = (ratio * 100) + '%';
        if (progress) progress.setAttribute('aria-valuenow', Math.min(subtotal, threshold));

        if (!reached) {
          var remaining = Math.max(threshold - subtotal, 0);
          var textEl = card.querySelector('.gift-reward__unreached-text');
          if (textEl) textEl.innerHTML = self.unreachedTemplate.replace('__AMOUNT__', self.formatMoney(remaining));
        }
      });

      this.updateBadge(reachedCount);
      if (newlyUnlocked) this.maybeAutoOpen();
      this.isFirstRender = false;
    }

    updateBadge(count) {
      if (!this.badge) return;
      if (count > 0) { this.badge.textContent = String(count); this.badge.hidden = false; }
      else { this.badge.hidden = true; }
    }

    formatMoney(cents) {
      var amount = (cents || 0) / 100;
      try { return new Intl.NumberFormat(this.locale, { style: 'currency', currency: this.currency }).format(amount); }
      catch (e) { return amount.toFixed(2) + ' €'; }
    }

    maybeAutoOpen() {
      if (!this.autoOpen) return;
      if (this.autoOpenOnce) {
        try {
          if (sessionStorage.getItem(AUTO_OPEN_SESSION_KEY)) return;
          sessionStorage.setItem(AUTO_OPEN_SESSION_KEY, '1');
        } catch (e) {}
      }
      this.open();
    }

    toggle() { if (this.classList.contains('is-open')) this.close(); else this.open(); }

    open() {
      this.classList.add('is-open');
      this.toggleButton.setAttribute('aria-expanded', 'true');
      if (this.panel) this.panel.hidden = false;
      if (this.backdrop) this.backdrop.hidden = false;
    }

    close() {
      this.classList.remove('is-open');
      this.toggleButton.setAttribute('aria-expanded', 'false');
      var self = this;
      window.setTimeout(function () {
        if (!self.classList.contains('is-open')) {
          if (self.panel) self.panel.hidden = true;
          if (self.backdrop) self.backdrop.hidden = true;
        }
      }, 250);
    }

    handleKeydown(event) { if (event.key === 'Escape' && this.classList.contains('is-open')) this.close(); }
  }

  window.customElements.define('gift-reward-popup', GiftRewardPopup);
})();
